import React from "react";
import { config_menu } from "./configurationConstants.js";
import classes from "./ConfigurationPanel.module.css";
import Button from "../../framework/Button.js";
import Shortcut from "../../framework/Shortcut.js";
import { useSelector } from "react-redux";

const ConfigurationPanel = ({
  onConfigClick = () => {},
  activeComponent,
  onSave = () => {},
}) => {
  const { props } = useSelector(
    (state) => state.commonReducer.tabs[state.commonReducer.activeTabIndex]
  );
  return (
    <div className={classes["configuration-main-panel-container"]}>
      <div className={classes["configuration-main-panel"]}>
        {config_menu.map((item, index) => {
          return (
            <li
              key={`config_panel_${index}`}
              className={
                item.id === activeComponent.id
                  ? classes["configuration-panel-list-selected"]
                  : index === 0 && !props?.retailerId
                  ? classes["configuration-panel-list-disabled"]
                  : classes["configuration-panel-list"]
              }
              onClick={() => onConfigClick(item, index)}
            >
              <img
                src={
                  item.id === activeComponent.id
                    ? item.whiteIcon
                    : item.blackIcon
                }
                alt="search"
                width="30px"
                height="30px"
              />
              <div
                className={
                  item.id === activeComponent.id
                    ? classes["configuration-list-item-selected"]
                    : classes["configuration-list-item"]
                }
              >
                {item.label}
              </div>
            </li>
          );
        })}
      </div>
      <div className={classes["configuration-panel-save"]}>
        <Button
          onClick={onSave}
          label="Save Configuration"
          endIcon={<Shortcut keys={["Ctrl", "S"]} />}
        />
      </div>
    </div>
  );
};

export default ConfigurationPanel;
